'use client'
import {
  minifyGqlQuery
} from "./chunk-SQE4KWHX.mjs";
import {
  commonWhere
} from "./chunk-N55STAST.mjs";
import {
  LOCATION_QUERY
} from "./chunk-RJD7S7WV.mjs";
import {
  SCHEDULE_QUERY
} from "./chunk-5GNKV3HD.mjs";
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";
import {
  getContentfulSafeLocale
} from "./chunk-2QEV6CST.mjs";
import {
  gqlClient
} from "./chunk-DZ54PK2S.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/events/listing.ts
import { gql } from "graphql-request";
import {
  useInfiniteQuery,
  useQuery
} from "@tanstack/react-query";
import { Exception } from "@wbk/logger";
var QUERY = gql`
query getEventListing($lang: String, $limit: Int, $skip: Int, $where: EventFilter, $order: [EventOrder]) {
  eventCollection(locale: $lang, limit: $limit, skip: $skip, where: $where, order: $order) {
    total
    items {
      __typename
      sys { id }
      id
      title
      subtitle
      slug
      ticketingUrlSlug
      image11{${IMAGE_QUERY}}
      image31{${IMAGE_QUERY}}
      startingPrice
      currencyCode
      schedule{${SCHEDULE_QUERY}}
      isStreamingEvent
      zoneEntryIncluded
      streamingUrl 
      buttonLabel
      cardButtonLabel
      eventType
      buttonLink
      zone{
        id slug title zoneLogo{${IMAGE_QUERY}} sponsorLogo{${IMAGE_QUERY}} 
      }
      location{${LOCATION_QUERY}}
      category{id title slug}
      isComingSoon
      organizationSlug
      carousalCollection(limit: 10) {
        items {${IMAGE_QUERY}}
      }
    }
  }
}
`;
var getEventListing = (props) => __async(void 0, null, function* () {
  try {
    const res = yield gqlClient.request(minifyGqlQuery(QUERY), __spreadProps(__spreadValues({
      order: "order_ASC"
    }, props), {
      lang: getContentfulSafeLocale(props.lang),
      where: __spreadValues(__spreadValues({}, commonWhere), props.where)
    }));
    return __spreadProps(__spreadValues({}, res.eventCollection), {
      settledAt: Date.now()
    });
  } catch (error) {
    throw new Exception({ error, name: "getEventListingException" });
  }
});
var useGetEventsList = (props, options) => {
  return useQuery(__spreadProps(__spreadValues({}, options), {
    queryKey: ["getEventsList", props],
    queryFn: () => getEventListing(props)
  }));
};
var useGetInfiniteEventsList = (props, options) => {
  const perPage = props.perPage || props.limit || 10;
  return useInfiniteQuery(__spreadValues({
    queryKey: ["getInfiniteEventsList", props],
    queryFn: (_0) => __async(void 0, [_0], function* ({ pageParam = 1 }) {
      return getEventListing(__spreadProps(__spreadValues({}, props), { limit: perPage, skip: (pageParam - 1) * perPage }));
    }),
    initialPageParam: 1,
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      const current = lastPageParam || 1;
      const totalRendered = current * perPage;
      return lastPage.total > totalRendered ? current + 1 : void 0;
    },
    select: (data) => data.pages.flatMap((page) => page.items)
  }, options));
};

export {
  getEventListing,
  useGetEventsList,
  useGetInfiniteEventsList
};
//# sourceMappingURL=chunk-W7F66HOR.mjs.map